import * as React from 'react';

import FileSlides16 from './FileSlides16';

export const fileSlides16 = () => <FileSlides16 />;

export default {
    title: 'Icon|Fill|FileSlides16',
    component: FileSlides16,
    parameters: {
        notes: "`import FileSlides16 from 'box-ui-elements/es/icon/fill/FileSlides16';`",
    },
};
